import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ajoutanticoagulant',
  templateUrl: './ajoutanticoagulant.component.html',
  styleUrls: ['./ajoutanticoagulant.component.css']
})
export class AjoutanticoagulantComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /home/masdev/Documents/NEPHROSYSTEMLAST/nephrosystem-webapp/src/app/ajoutanticoagulant/ajoutanticoagulant.component.ts